// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__nqo3h","actionsCol":"EnrolledClinics_actionsCol__3xKYH"};